// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductTeaser-module--root--3DHcP","mock":"ProductTeaser-module--mock--1BH9-"};